import { useQueries, useQuery, UseQueryResult } from '@tanstack/react-query';
import { GetS3SignedUrl2 } from '../../utils/fetch-utils';

const BUCKET_NAME = 'bpm-cdn';

interface SlideImageRef {
  slideId: string;
  imageUrl: string;
}

const slideSignedUrlQueryOptions = (imageUrl: string) => ({
  queryKey: ['slideSignedUrl', imageUrl],
  queryFn: () => GetS3SignedUrl2(BUCKET_NAME, imageUrl)
});

// Signs a single slide's image URL. Cached by imageUrl in the shared React Query cache, so a
// slide already signed by useSlideIdToSignedUrl (or a previous mount) resolves instantly here
// with no duplicate network request.
export const useSlideSignedUrl = (imageUrl: string): UseQueryResult<string> =>
  useQuery(slideSignedUrlQueryOptions(imageUrl));

// Signs every slide's image URL in parallel and returns a slideId -> url map, falling back to
// the original (unsigned) imageUrl per-slide if signing fails.
export const useSlideIdToSignedUrl = (slides: SlideImageRef[]): Record<string, string> => {
  const results = useQueries({
    queries: slides.map(slide => slideSignedUrlQueryOptions(slide.imageUrl))
  });

  return Object.fromEntries(
    slides.map((slide, index) => [slide.slideId, results[index]?.data || slide.imageUrl])
  );
};
